module.exports = __webpack_public_path__ + "static/media/more-options-dark.17e23e0e.svg";